module.exports = __webpack_public_path__ + "static/img/rank_27.0e1fbba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_27.png
// module id = 3Ei7
// module chunks = 0